import { AuthenticatedDataRequest } from '@eggplant/data-request'
import { NOTIFICATION_SERVICE } from '@eggplant/api-hosts'
import type { ReactElement } from 'react'
import type { WebhookProfile } from '@eggplant/types'

interface Props {
  webhookUuid: string
  params: WebhookProfile
  onSuccess?: () => void
  children?: () => ReactElement
}

const UpdateWebhookRequest = ({
  webhookUuid,
  params,
  onSuccess,
  children
}: Props) => {
  const url = `${NOTIFICATION_SERVICE}/webhooks/${webhookUuid}`

  return (
    <AuthenticatedDataRequest
      children={children}
      method='put'
      onSuccess={onSuccess}
      params={params}
      url={url}
    />
  )
}

export default UpdateWebhookRequest
